/** App shell built with skarn chrome: titlebar, ribbon tabs, status bar. */

export interface Shell {
  pages: { sender: HTMLElement; receiver: HTMLElement };
  setStatus(text: string): void;
}

type TabKey = 'sender' | 'receiver';

function tabFromHash(): TabKey {
  return window.location.hash.replace('#', '') === 'receiver' ? 'receiver' : 'sender';
}

export function createShell(): Shell {
  const ui = window.__SKF_UI;
  const app = document.getElementById('app');
  if (!app) throw new Error('missing #app element');
  app.className = 'qwerty-app skf-flow-root';

  const titlebar = ui.el('header', 'skf-titlebar qwerty-titlebar');
  const start = ui.el('div', 'skf-tb-start');
  const brand = ui.el('div', 'qwerty-brand');
  brand.innerHTML = '<span class="qwerty-mark">&#9672;</span><span>QweRty</span>';
  const tagline = ui.el('span', 'skf-caption skf-label-dim qwerty-tagline', '摄像头二维码传输');
  start.append(brand, tagline);

  const tabs = ui.tabs(
    [
      { key: 'sender', label: '发送', onSwitch: () => { window.location.hash = 'sender'; } },
      { key: 'receiver', label: '接收', onSwitch: () => { window.location.hash = 'receiver'; } },
    ],
    { activeKey: tabFromHash() },
  );
  tabs.root.classList.add('qwerty-tabs');

  // Keep the tab in sync with the URL hash so a phone can open /#receiver.
  window.addEventListener('hashchange', () => {
    const key = tabFromHash();
    const tab = tabs.tabOf[key];
    if (tab && tabs.activeKey !== key) tab.click();
  });

  const end = ui.el('div', 'skf-tb-end');
  titlebar.append(start, tabs.root, end);

  const main = ui.el('main', 'qwerty-body');
  tabs.pages.classList.add('qwerty-pages');
  main.appendChild(tabs.pages);

  const statusbar = ui.el('footer', 'skf-statusbar');
  const statusText = ui.el('span', 'skf-status-dim', '就绪');
  statusbar.appendChild(statusText);

  app.append(titlebar, main, statusbar);

  const sender = tabs.pageOf['sender'];
  const receiver = tabs.pageOf['receiver'];
  if (!sender || !receiver) throw new Error('skarn tabs did not create pages');

  return {
    pages: { sender, receiver },
    setStatus(text: string) {
      statusText.textContent = text;
    },
  };
}
